/*
 * TodoConstants
 */

import keyMirror from 'keymirror'

const SegmentConstants = keyMirror({
  RENDER_SEGMENTS: null,
  ADD_SEGMENTS: null,
  ADD_SEGMENT_CLASS: null,
  ADD_SEGMENTS_CLASS: null,
  REMOVE_SEGMENT_CLASS: null,
  PROPAGATE_TRANSLATION: null,
  SET_SEGMENT_STATUS: null,
  UPDATE_SEGMENTS: null,
  SET_SEGMENT_HEADER: null,
  HIDE_SEGMENT_HEADER: null,
  SET_SEGMENT_PROPAGATION: null,
  REPLACE_TRANSLATION: null,
  REPLACE_SOURCE: null,
  MODIFIED_TRANSLATION: null,
  UPDATE_TRANSLATION: null,
  SET_SEGMENT_ORIGINAL_TRANSLATION: null,
  UPDATE_SOURCE: null,
  ADD_EDITAREA_CLASS: null,
  TRANSLATION_EDITED: null,
  UPDATE_ALL_SEGMENTS: null,
  CREATE_FOOTER: null,
  SHOW_FOOTER_MESSAGE: null,
  REGISTER_TAB: null,
  MODIFY_TAB_VISIBILITY: null,
  CLOSE_TABS: null,
  SET_DEFAULT_TAB: null,
  SET_CONTRIBUTIONS: null,
  SET_CL_CONTRIBUTIONS: null,
  CHOOSE_CONTRIBUTION: null,
  DELETE_CONTRIBUTION: null,
  SET_GLOSSARY_TO_CACHE: null,
  SET_GLOSSARY_TO_CACHE_BY_SEARCH: null,
  CHANGE_GLOSSARY: null,
  ERROR_CHANGE_GLOSSARY: null,
  DELETE_FROM_GLOSSARY: null,
  ERROR_DELETE_FROM_GLOSSARY: null,
  ADD_GLOSSARY_ITEM: null,
  ERROR_ADD_GLOSSARY_ITEM: null,
  SET_SEGMENT_TAGGED: null,
  SHOW_SELECTION: null,
  OPEN_ISSUES_PANEL: null,
  CLOSE_ISSUES_PANEL: null,
  SHOW_ISSUE_MESSAGE: null,
  ADD_SEGMENT_VERSIONS_ISSUES: null,
  ADD_SEGMENT_PRELOADED_ISSUES: null,
  OPEN_TAB: null,
  RENDER_PREVIEW: null,
  ISSUE_ADDED: null,
  ISSUE_DELETED: null,
  OPEN_ISSUE_COMMENT: null,
  ADD_TAB_INDEX: null,
  TOGGLE_SEGMENT_ON_BULK: null,
  REMOVE_SEGMENTS_ON_BULK: null,
  SET_UNLOCKED_SEGMENT: null,
  SET_UNLOCKED_SEGMENTS: null,
  SET_BULK_SELECTION_INTERVAL: null,
  SET_BULK_SELECTION_SEGMENTS: null,
  SET_MUTED_SEGMENTS: null,
  REMOVE_MUTED_SEGMENTS: null,
  FIND_CONCORDANCE: null,
  CONCORDANCE_RESULT: null,
  SET_SEGMENT_WARNINGS: null,
  UPDATE_GLOBAL_WARNINGS: null,
  QA_LEXIQA_ISSUES: null,
  LOCK_EDIT_AREA: null,
  UNLOCK_EDIT_AREA: null,
  OPEN_TAGS_MENU: null,
  CLOSE_TAGS_MENU: null,
  SET_OPEN_SEGMENT: null,
  OPEN_SEGMENT: null,
  CLOSE_SEGMENT: null,
  SCROLL_TO_SEGMENT: null,
  SCROLL_TO_SELECTED_SEGMENT: null,
  OPEN_SIDE: null,
  CLOSE_SIDE: null,
  OPEN_COMMENTS: null,
  CLOSE_COMMENTS: null,
  OPEN_SPLIT_SEGMENT: null,
  CLOSE_SPLIT_SEGMENT: null,
  SET_CHOOSEN_SUGGESTION: null,
  SET_ALTERNATIVES: null,
  SET_QA_CHECK: null,
  ADD_LXQ_HIGHLIGHT: null,
  ADD_SEARCH_RESULTS: null,
  REMOVE_SEARCH_RESULTS: null,
  ADD_CURRENT_SEARCH: null,
  FOCUS_EDITAREA: null,
  FILL_TAGS_IN_TARGET: null,
  SELECT_SEGMENT: null,
  SET_PROGRESS: null,
  UPDATE_CURSOR: null,
  FORCE_UPDATE_SEGMENT: null,
  UPDATE_SEARCH: null,
  SET_GUESS_TAGS: null,
  HIGHLIGHT_TAGS: null,
  SET_SEGMENT_SAVING: null,
  HIDE_AI_ASSISTANT: null,
  CHARACTER_COUNTER: null,
  GET_MORE_SEGMENTS: null,
  REMOVE_ALL_SEGMENTS: null,
  FREEZING_SEGMENTS: null,
  GET_SEGMENT_QA: null,
  HIGHLIGHT_GLOSSARY_TERM: null,
  HELP_AI_ASSISTANT: null,
  AI_SUGGESTION: null,
  SET_IS_CURRENT_SEARCH_OCCURRENCE_TAG: null,
  OPEN_GLOSSARY_FORM_PREFILL: null,
  FOCUS_TAGS: null,
  REFRESH_TAG_MAP: null,
  CHANGE_CHARACTERS_COUNTER_RULES: null,
  SET_CURRENT_SEGMENT_ID: null,
  LARA_STYLES: null,
  AI_ALTERNATIVES: null,
  AI_FEEDBACK: null,
  AI_ALTERNATIVES_SUGGESTION: null,
  AI_FEEDBACK_SUGGESTION: null,
})
export default SegmentConstants
